 <template>
  <Dashboard>
    <template v-slot:title>
      <h2>{{$t("products.title")}}</h2>
    </template>
    <template v-slot:filter>
      <div class="relative">
        <button
          @click="show.filter = !show.filter"
          class="outline"
        >
          <i class="fas fa-filter fa-flip-horizontal"></i>
          {{$t("button.filter")}}
        </button>
        <Filtres
          :options="options"
          :products="products"
          v-if="show.filter"
          @wipe="wipeFilter()"
          @filter="getFilter"
        ></Filtres>
      </div>
    </template>
    <template
      v-slot:buttonRight
      v-if="$store.getters.USERPROFILE['product-administration']"
    >
      <button @click="show.add=true">
        <i class="fas fa-plus"></i>
        {{$t("button.createProduct")}}
      </button>
      <AddInBox
        v-if="show.add"
        @newproduct="getProducts"
        @close="show.add=false"
      >
      </AddInBox>
      <ModifyProductInBox
        v-if="show.update"
        :parProductId="productToModifyId"
        @productupdated="getProducts"
        @close="show.update=false"
      >
      </ModifyProductInBox>
    </template>
    <template
      v-slot:tab
      v-if="products.length > 0"
    >
      <thead>
        <tr class="trHead">
          <th
            v-for="item in tab"
            :key="item.title"
            class="accentuate"
          >
            <div class="row">
              {{item.title}}
              <div class="column sort">
                <i
                  v-if="sort.order == -1  && item.sort==sort.type "
                  class="fas fa-sort-up up blueColor"
                  @click="(sort.type = item.sort) && (sort.order = 1)"
                ></i>
                <i
                  v-else-if="sort.order == 1 && item.sort==sort.type"
                  class="fas fa-sort-down down blueColor"
                  @click="(sort.type = item.sort) && (sort.order = -1)"
                ></i>
                <i
                  v-else-if="sort.order == 1|| item.sort!=sort.type"
                  class="fas fa-sort-down down"
                  @click="(sort.type = item.sort) && (sort.order = -1)"
                ></i>
              </div>
            </div>
          </th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="data in sortProducts"
          :key="data.title"
        >
          <td>{{data['merchant-reference']}}</td>
          <td>{{data.name}}</td>
          <td>{{data.merchantName}}</td>
          <td>
            <p
              v-if="data.archived"
              class="chip cGrey"
            >{{$t('productStatus.archived')}}</p>
          </td>
          <td class="bubbleParent">
            <button
              ref="bubble"
              class="outline"
              @click="bubbleClick(data.id)"
            >
              <img
                ref="bubble"
                class="pastille"
                src="@/assets/images/pastille.png"
                alt="pastille"
              >
            </button>
            <div
              class="bubble"
              v-if="bubbleAction(data.id)"
            >
              <a
                v-if="!data['archived']"
                @click="prepareModify(data.id)"
              >{{$t('products.modifyAction')}}</a>

              <a
                v-if="!data['archived']"
                @click="archive(data)"
                class="redText"
              >{{$t('products.archiveAction')}}</a>
              <a
                v-if="data['archived']"
                @click="archive(data)"
              >{{$t('products.unArchiveAction')}}</a>
            </div>
          </td>
        </tr>
      </tbody>
    </template>
    <template
      v-slot:tab
      v-else
    >
      <NoProduct></NoProduct>
    </template>
  </Dashboard>
</template>

<script>
import Filtres from "@/components/products/Filtres";
import Products from "@/services/Products.js";
import SalesChannels from "@/services/SalesChannels.js";
import Dashboard from "@/components/layout/Dashboard";
import NoProduct from "./NoProduct";
import bubble from "@/mixins/bubble";
import compare from "@/mixins/compare";
import AddInBox from "@/components/products/AddInBox";
import ModifyProductInBox from "@/components/products/ModifyProductInBox";
export default {
  mixins: [bubble, compare],
  components: {
    NoProduct,
    Dashboard,
    Filtres,
    AddInBox,
    ModifyProductInBox
  },
  data() {
    return {
      productToModifyId: "",
      salesChannelList: [],
      products: [],
      show: {
        filter: false,
        add: false,
        update: false
      },
      sort: {
        order: -1,
        type: "name"
      },
      options: {
        isActive: true,
        isArchived: true,
        merchantName: {}
      }
    };
  },
  mounted() {
    this.getProducts();
  },

  computed: {
    tab() {
      return [
        { title: this.$t("products.productCode"), sort: "merchant-reference" },
        { title: this.$t("products.productName"), sort: "name" },
        { title: this.$t("products.salesChannel"), sort: "sales-channel-name" }
      ];
    },
    sortProducts: function() {
      const products = this.filterProducts;
      return products.sort(this.compare);
    },
    filterProducts: function() {
      return this.products.filter(product => {
        switch (product.archived) {
          case true:
            if (this.options.isArchived) {
              return this.filterMerchant(product);
            } else {
              return false;
            }
          case false:
            if (this.options.isActive) {
              return this.filterMerchant(product);
            } else {
              return false;
            }
        }
      });
    }
  },

  methods: {
    prepareModify(id)
    {
      this.productToModifyId=id;
      this.show.update=true
    },
    filterMerchant(product) {
      if (Object.keys(this.options.merchantName).length == 0) {
        return true;
      } else {
        let merchant = this.options.merchantName[product["sales-channel-name"]];
        if (merchant && merchant == true) {
          return true;
        } else {
          return false;
        }
      }
    },
    wipeFilter() {
      this.show.filter = false;
      this.options = {
        isActive: true,
        isArchived: true,
        merchantName: {}
      };
    },
    getProducts() {
      //récupération des profils
      var localsaleschannellist = [];
      SalesChannels.get().then(res => {
        for (var i = 0; i < res.data.length; i++) {
          var paramobj = {
            id: res.data[i].id,
            merchantName:
              res.data[i].name + " (" + res.data[i]["merchant-name"] + ")"
          };

          localsaleschannellist.push(paramobj);
        }
        this.salesChannelList = localsaleschannellist;

        Products.get().then(res => {
          switch (res.status) {
            case 200:
              this.users = res.data;
              //affectation des profils pour chacun des utilisateurs
              this.getMerchantName(res.data);
              break;
            case 401:
              this.$router.push({ name: "noAccess" });
              break;
            default:
              this.$router.push({ name: "noService" });
              break;
          }
        });
      });
    },
    archive(data) {
      Products.partialUpdate(data.id, { archived: !data.archived }).then(
        res => {
          if (res.status == 204) data.archived = !data.archived;
        }
      );
    },
    getMerchantName(products) {
      for (let i = 0; i < products.length; i++) {
        var index = products[i]["channel-id"];
        products[i].merchantName = this.salesChannelList.find(
          x => x.id === index
        ).merchantName;
      }
      this.products = products;
    },
    getFilter(data) {
      this.options = data;
      this.show.filter = false;
    }
  }
};
</script>

<style scoped>
.cGrey {
  background-color: #b1b1b1;
}
.sort {
  position: relative;
  margin-right: 5px;
}
.sort i {
  position: absolute;
}
.down {
  top: -15px;
  left: 5px;
}
.up {
  top: -10px;
  left: 5px;
}
</style>